import { Controller } from '@hotwired/stimulus'
import Chart from 'chart.js/auto'
import { metrics } from '../routes'

export default class extends Controller {
  static targets = ['days', 'metric', 'duration', 'chart']

  connect () {
    this.visits = []
    this.users = []
    this.chart = this.initializeChart(this.chartTarget, 'line')
    this.updateMetrics()
  }

  initializeChart (element, chartType) {
    const ctx = element.getContext('2d')
    return new Chart(ctx, {
      type: chartType,
      data: {
        labels: [],
        datasets: [
          {
            label: 'Kingdom Labs',
            data: this.visits,
            borderColor: 'blue',
            backgroundColor: 'blue',
            fill: false,
            borderJoinStyle: 'round',
            tension: 0.4
          },
          {
            label: 'Fuse',
            data: this.visits,
            borderColor: 'red',
            backgroundColor: 'red',
            fill: false,
            borderJoinStyle: 'round',
            tension: 0.4
          }
        ]
      },
      options: {
        responsive: true,
        aspectRatio: 1.5,
        scales: {
          y: {
            beginAtZero: true
          }
        },
        elements: {
          point: {
            radius: 0
          }
        },
        animation: {
          duration: 250
        }
      }
    })
  }

  async updateMetrics () {
    const selectedRadio = document.querySelector('input[name="days"]:checked')
    const selectedMetric = document.getElementById('selectedMetric').value
    const days = parseInt(selectedRadio.value, 10)

    let duration
    switch (document.getElementById('selectedDuration').value) {
      case 'All Time':
        duration = Math.floor(Date.now() / (1000 * 60 * 60 * 24))
        break
      case '30 Days':
        duration = 30
        break
      case '1 Week':
        duration = 7
        break
      case 'Single Day':
        duration = 1
        break
    }

    // Fetch metrics data from the backend API
    const url = metrics() + `?days=${days}&duration=${duration}&metric=${selectedMetric}`
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      }
    })
    const data = await response.json()
    this.updateChart(data, duration)
  }

  updateChart (data, duration) {
    const chartType = duration === 1 ? 'bar' : 'line'
    if (this.chart.type !== chartType) {
      this.chart.destroy()
      this.chart = this.initializeChart(this.chartTarget, chartType)
    }
    this.chart.data.labels = this.visits.map((_, index) => `Day ${index + 1}`)
    data.forEach((element, index) => {
      this.chart.data.datasets[index].data = element[1]
    })
    this.chart.update()
  }
}
